import { Avatar } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons';

type Props = {
	displayName: string;
	photo: {
		userMedium: {
			processing: boolean;
			url: string;
		};
	} | null;
};

export function DmAvatar({ displayName, photo }: Props): React.JSX.Element {
	const photoUrl = photo?.userMedium.processing ? undefined : photo?.userMedium.url;

	return (
		<div className="z-[9] flex w-20 shrink-0 flex-col items-center -space-y-8">
			<Avatar src={photoUrl} size={80} alt={`avatar for ${displayName}`} />
			<div
				data-testid="dm-title-icon"
				className="z-10 flex h-[56px] w-[56px] items-center justify-center gap-1.5 rounded-full border-4 border-solid border-stroke-inverse-strong bg-fill-accent-primary-weaker p-1"
			>
				<span>
					<DecisionMakerIcon className="h-6 w-6 text-typography-accent-primary" />
				</span>
			</div>
		</div>
	);
}
